import React from 'react';
import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField, LookupField } from 'react/components/fields';

const TicketResolutionCrud = (props) => (
  <BaseCrud updateMethod="PATCH" tabName="TicketResolution.title" {...props}>
    <FormSection title="TicketResolution.section.general.title" className="generalSection">
      <FormSectionColumn>
        <LookupField
          label="TicketResolution.field.organization"
          name="organization"
          lookupEntity="Organization"
          lookupEntityColumn="description"
          required
        />
        <TextField
          label="TicketResolution.field.description"
          name="description"
          required
        />
      </FormSectionColumn>
    </FormSection>
  </BaseCrud>
);

export default TicketResolutionCrud;
